// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__-2GGO","titleContainer":"styles_titleContainer__xKDdS","title":"styles_title__NiopS","userToggler":"styles_userToggler__eTwA8"};